export function iniciarMenuUsuario() {
    const boton = document.querySelector('.user-button');
    const menu = document.querySelector('.dropdown-menu');

    // Si no existe el menú en la página, no ejecutamos nada.
    if (!boton || !menu) {
        return;
    }

    // Abre o cierra el menú al hacer clic en el botón.
    boton.addEventListener('click', function (event) {
        event.stopPropagation();

        menu.classList.toggle('show');
        boton.classList.toggle('active');
    });

    // Evita que el clic dentro del menú lo cierre inmediatamente.
    menu.addEventListener('click', function (event) {
        event.stopPropagation();
    });

    // Cierra el menú cuando se hace clic en otra parte de la página.
    document.addEventListener('click', function () {
        menu.classList.remove('show');
        boton.classList.remove('active');
    });

    // Cierra el menú con la tecla Escape.
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            menu.classList.remove('show');
            boton.classList.remove('active');
        }
    });
}